import { ChatBubble } from '@/flows/outreach/components/chat-bubble.js';
import { Button } from '@/components/button.js';
import { DeadEndAttachment } from '@/flows/outreach/components/dead-end-attachment.js';

interface ChatErrorProps {
  /** Dealer-voice line, rendered as a chat bubble. */
  message: string;
  /** Omit to hide the retry CTA — the error then reads as a terminal state. */
  onRetry?: () => void;
}

/** Retry sits in the composer slot where every other chat action lives. */
export function ChatError({ message, onRetry }: ChatErrorProps) {
  return (
    <div className="sm-stack sm-chat-shell">
      <div className="sm-stack sm-chat-scroll">
        <div className="sm-stack sm-chat-thread">
          <ChatBubble side="dealer">{message}</ChatBubble>
          <DeadEndAttachment />
        </div>
      </div>
      {onRetry !== undefined ? (
        <div className="sm-stack sm-chat-composer">
          <div className="sm-stack sm-chat-composer-inner">
            <Button onClick={onRetry} endIcon={null}>
              Try again
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
